export default __webpack_public_path__ + "static/media/logo-sso-okta-white.52d3f955.svg";